import React, { useLayoutEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import style from '../AccordionCard.style';
import { scrollAccordionCardIntoView } from '../../../../features/CnC/SinglePageCheckout/container/SinglePageCheckout.utils';
import useAccordionTransition from '../hooks/useAccordionTransition';

export const AccordionCard = forwardRef((props, ref) => {
  const {
    header,
    children,
    className,
    cardClassName,
    isExpanded,
    isActive,
    accordionCardRefId,
    transitionConfig,
    recalculateHeight,
    bossSwitchEnabled,
  } = props;

  useLayoutEffect(() => {
    if (isActive && ref && ref.current && !bossSwitchEnabled) {
      scrollAccordionCardIntoView(ref, accordionCardRefId, bossSwitchEnabled);
    }
  }, [isActive]);

  const [contentRef] = useAccordionTransition({
    isExpanded,
    recalculateHeight,
    ...transitionConfig,
  });

  return (
    <section ref={ref} className={`${className} ${bossSwitchEnabled ? '' : 'spc-card-container'}`}>
      {!bossSwitchEnabled && (
        <div
          ref={contentRef}
          component="div"
          className={`spc-card accordion-div ${cardClassName} ${
            !isExpanded ? 'collapsed' : 'expand'
          }`}
          aria-expanded={isExpanded ? 'true' : 'false'}
        >
          {header}
          {children}
        </div>
      )}
      {bossSwitchEnabled && (
        <div
          ref={contentRef}
          component="div"
          className={`${cardClassName}`}
          aria-expanded={isExpanded ? 'true' : 'false'}
        >
          {header}
          {children}
        </div>
      )}
    </section>
  );
});

AccordionCard.propTypes = {
  header: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  cardClassName: PropTypes.string,
  isExpanded: PropTypes.bool.isRequired,
  isActive: PropTypes.bool,
  accordionCardRefId: PropTypes.string,
  transitionConfig: PropTypes.shape({}),
  recalculateHeight: PropTypes.bool,
};

AccordionCard.defaultProps = {
  className: '',
  cardClassName: '',
  isActive: false,
  accordionCardRefId: '',
  transitionConfig: {},
  recalculateHeight: false,
};

export default withStyles(AccordionCard, style);
